import { useRef, useState } from "react"
import { ConfigProvider, Card } from "antd"
import locale from "antd/es/locale/zh_CN"
import KnowledgeGraphCard from "./knowledge-graph" // 知识图谱
import HyperTextLinkMsgCard from "./hyper-text-link" // 快速访问超链接
import SourceArticleCard from "./source-article" // 原文展示
import RelationMattersCard from "./relation-matters" // 相关事项
import AttachmentCard from "./attachment" // 附件展示
import ReferenceMessageCard from "./reference-message"
import HTMLCard from "./html"
import ChatCard from "./chat"
import HasManualStoppedCard from "./has-manual-stopped"
import "./index.less"
import PieChart from "./pie-chart"
import TodoCard from "./todo-card"
import DaysCard from "./days"
import NewsCard from "./news/index"


function MessageCard(chatInstance) {
  const ref = useRef()
  const { msgId, meta, ...msg } = chatInstance
  const [stopStream, setStopStream] = useState(false)
  console.log("消息", msg)

  if (meta?.pending || !msg) {
    return null
  }

  return (
    <ConfigProvider locale={locale}>


      <div
        className='msg-main-container'
        id={msg?.chart?.type ? "pie-container" : "defaut-container"}
      >

        {!msg?.form && (
          <div>
            {msg.chat_qa ? <ChatCard msg={msg} chatInstance={chatInstance} /> : ""}

            {!msg.auditStatus && !msg?.s_filter ? (
              <>
                {msg.attachmentList && msg.attachmentList.length ? (
                  <div className='inner_card type-2'>
                    <AttachmentCard
                      className='inner_card'
                      msg={msg}
                      chatInstance={chatInstance}
                    ></AttachmentCard>
                  </div>
                ) : (
                  ""
                )}

                {msg.graph && msg.graph.matchItems.length ? (
                  <div className='inner_card type-3'>
                    <KnowledgeGraphCard msg={msg} chatInstance={chatInstance}></KnowledgeGraphCard>
                  </div>
                ) : (
                  ""
                )}

                {msg.urlList && msg.urlList.length ? (
                  <div className='inner_card type-4'>
                    <HyperTextLinkMsgCard
                      msg={msg}
                      chatInstance={chatInstance}
                    ></HyperTextLinkMsgCard>
                  </div>
                ) : (
                  ""
                )}

                {msg.content && msg.content !== "" ? (
                  <div className='inner_card type-5'>
                    <SourceArticleCard msg={msg} chatInstance={chatInstance}></SourceArticleCard>
                  </div>
                ) : (
                  ""
                )}
                {/* hmtl */}
                {!msg.chat_qa && msg.html && msg.html.length ? (
                  <div className='inner_card type-6'>
                    <HTMLCard msg={msg} chatInstance={chatInstance}></HTMLCard>
                  </div>
                ) : (
                  ""
                )}

                {msg.relaItems && msg.relaItems.length ? (
                  <div className='inner_card type-7'>
                    <RelationMattersCard
                      msg={msg}
                      chatInstance={chatInstance}
                    ></RelationMattersCard>
                  </div>
                ) : (
                  ""
                )}

                {msg.reference && (msg.reference.referenceList.length || msg.reference.text) ? (
                  <div className='inner_card type-8'>
                    <ReferenceMessageCard
                      msg={msg}
                      chatInstance={chatInstance}
                    ></ReferenceMessageCard>
                  </div>
                ) : (
                  ""
                )}
                {msg?.chart && msg?.chart?.type ? (
                  <div className='inner_card type-9 '>
                    <PieChart msg={msg} chatInstance={chatInstance}></PieChart>
                  </div>
                ) : (
                  ""
                )}

                {msg?.app && msg?.app.type === "daiban" && (
                  <Card>
                    <TodoCard msg={msg} chatInstance={chatInstance} />
                  </Card>
                )}
                {msg?.app && msg?.app.type === "xiaoxi" && (
                  <Card>
                    <NewsCard msg={msg} chatInstance={chatInstance} />
                  </Card>
                )}

                {msg?.app && msg?.app.type === "richeng" && (
                  <Card>
                    <DaysCard msg={msg} chatInstance={chatInstance} />
                  </Card>
                )}
              </>
            ) : (
              <></>
            )}

            <HasManualStoppedCard msg={msg} chatInstance={chatInstance}></HasManualStoppedCard>
          </div>
        )}
      </div>

      {/* {msg.isFinished || stopStream ? (
        !msg.auditStatus && !msg?.s_filter && msg.isAnswer ? (
          <MessageFeedback chatInstance={chatInstance} />
        ) : null
      ) : msg.isAI ? (
        <div className='inner_card type-9'>

        </div>
      ) : null} */}
    </ConfigProvider>
  )
}

export default MessageCard
